import {
  GET_VEHICLE_CONTRACTS_LOADING,
  GET_VEHICLE_CONTRACTS_FAILED,
  GET_VEHICLE_CONTRACTS_SUCCESS,
} from "../types"
  
  const initialState = {
    bookings: [],
    loading: false,
    error: false,
    empty: false,
  }

  export default function (state = initialState, action) {
    switch (action.type) {
      case GET_VEHICLE_CONTRACTS_LOADING:
        return {
          ...state,
          loading: true,
          error: false,
          empty: false,
          vehicle_contracts: [],
        }
      case GET_VEHICLE_CONTRACTS_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          empty: false,
          vehicle_contracts: [],
        }
      case GET_VEHICLE_CONTRACTS_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          empty: action.payload.length == 0,
          vehicle_contracts: action.payload,
        }
      default:
        return state
    }
  }
  